
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-an-instructor",
      function () {
        return require("private-next-pages/become-an-instructor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-an-instructor"])
      });
    }
  